/* eslint-disable react-hooks/rules-of-hooks */
import { axiosInstance } from "@/lib/axiosInstance";
import config from "@/lib/config";
import axios from "axios";
import { z } from "zod";

export const InitiateStkPushSchema = z.object({
  // to remove amount from here
  amount: z.number(),
  phone: z.string().min(10),
  orderId: z.string(),
  companyId: z.string(),
});

export type InitiateStkPushSchemaType = z.infer<typeof InitiateStkPushSchema>;

export async function initiateStkPush(formData: InitiateStkPushSchemaType) {
  try {
    const response = await axiosInstance.post(
      `${config.apiUrl}/payments/mpesa/stk-push`,
      formData
    );
    return response.data.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Axios error:", error.response?.data);
    } else {
      console.error("Unknown error:", error);
    }
    throw error;
  }
}
